jQuery(document).on('ready', function(){
	ZOOM.onReady();
});



var ZOOM = {
	onReady: function(){
		jQuery(document).on('click', '.video-play.zoom-api', ZOOM.initZoom);
	},



	initZoom: function(){
		if ( jQuery(event.target).hasClass('video-play') ) {
			ZOOM.context 	= jQuery(this).closest('.video');
			ZOOM.id 		= jQuery(this).attr('data-zmid');
			ZOOM.pwd 		= jQuery(this).attr('data-zmpwd');


			jQuery.when(BASE.getUser()).then(() => {
				jQuery('.video-preview-, .video-embet, .video-info', ZOOM.context).hide();
				jQuery(ZOOM.context).addClass('is-playing');

				jQuery(ZOOM.context).append('<div class="is_media"><iframe src="' + kdkJS.tplUrl + '/tpl/public-zoom-iframe.php?zmid=' + ZOOM.id + '&zmpwd=' + ZOOM.pwd + '&username=' + BASE.userName + '&color-primary=' + kdkJS.colorPrimary + '" frameborder="0" allow="camera;microphone;geolocation" style="width:100%;height:100%;"></iframe></div>');
				
			});

			return false;

		} else { // direct link
		}
	},
}